import { render } from "./S173110.vue?vue&type=template&id=59619630"
const script = {}
script.render = render

export default script